import { useTranslation } from 'react-i18next';
import { BottomSheet } from '@/components/ui/BottomSheet';

interface AcademicYearResetModalProps {
  open: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * High-friction confirmation required before an academic-context change (US-PRF-02)
 * — that update hard-deletes the timetable, free time, and commitments (US-PRF-01),
 * so the user must explicitly acknowledge the wipe before it happens. Built on the
 * existing BottomSheet design-system component rather than custom modal CSS.
 */
export function AcademicYearResetModal({
  open,
  isSaving,
  onCancel,
  onConfirm,
}: AcademicYearResetModalProps) {
  const { t } = useTranslation();

  return (
    <BottomSheet open={open} onClose={onCancel} title={t('academic_context.confirm_title')}>
      <p style={{ margin: '0 0 20px', fontSize: '0.9rem', color: 'var(--text-dark)', lineHeight: 1.6 }}>
        {t('academic_context.confirm_body')}
      </p>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          type="button"
          className="btn btn-outline"
          onClick={onCancel}
          disabled={isSaving}
          style={{ flex: 1 }}
        >
          {t('actions.cancel')}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onConfirm}
          disabled={isSaving}
          style={{ flex: 1, background: 'var(--danger)', borderColor: 'var(--danger)' }}
        >
          {isSaving ? t('actions.saving') : t('academic_context.confirm_continue')}
        </button>
      </div>
    </BottomSheet>
  );
}
